import React from "react";
import { Popover, PopoverContent, PopoverTrigger } from "components/ui/popover";
import { Info } from "lucide-react";

interface TooltipProps {
  text: string;
}

const Tooltip: React.FC<TooltipProps> = ({ text }) => {
  return (
    <Popover>
      <PopoverTrigger asChild>
        <button type="button">
          <Info className="h-4 w-4 text-gray-400 hover:text-gray-800" />
        </button>
      </PopoverTrigger>
      <PopoverContent className="w-64 p-2 text-sm" side="top" align="center">
        {text}
      </PopoverContent>
    </Popover>
  );
};

export default Tooltip;
